// extracted by mini-css-extract-plugin
export default {"inputText":"InputText_inputText__v8M48"};